<template>
  <div>
    <InputLabel
      v-if="labelValue"
      :required="required"
      :label="labelValue"
    />
    <select
      :name="name"
      :value="modelValue"
      :disabled="disabled"
      :required="required"
      class="px-6 rounded-full h-16"
      :class="[{
        'border-red-600': hasError(),
        'border-gray-300': !hasError(),
      }, inputClass]"
      @change="inputListener(transformInputValue($event))"
    >
      <option
        v-if="required"
        selected
        disabled
        hidden
        value=""
      >
        Select an option
      </option>
      <slot />
    </select>
    <p
      v-if="hasError()"
      class="mt-1 form-input-error"
    >
      {{ errorMessage() }}
    </p>
  </div>
</template>
<script>
import InputBase from "./InputBase";
import InputLabel from "../components/InputLabel.vue";
export default {
  name: "v-input-select",
  components: { InputLabel },
  extends: InputBase,
  props: {
    modelValue: {
      required: true,
      validator(value) {
        return _.isNumber(value) || _.isString(value) || value === null || value === undefined;
      }
    }
  },
  methods: {
    transformInputValue(event) {
      if (event === null) {
        return null;
      }
      const value = _.get(event, "target.value", null);
      if (value === null) {
        return null;
      }
      return value;
    }
  }
};
</script>
